import HorizontalSeparator from './HorizontalSeparator'

export { HorizontalSeparator }
